import type { AxiosInstance } from "axios"
import type { TimePeriodMeetingService } from "../../../merchant/merchant/production/meetingService/meetingServiceTypes"

import type { UpcomingMeetingsResponse } from "./upcomingMeetingsTypes"

export enum ServiceCenterUpcomingMeetingsQuery {
    UPCOMING_MEETINGS = "upcoming-meetings-for-service-center",
}

type ServiceCenterUpcomingMeetingsParams = Readonly<{
    serviceCenterId: number
    period?: TimePeriodMeetingService
    startDate?: string
    endDate?: string
}>

export async function fetchServiceCenterUpcomingMeetings(
    { serviceCenterId, ...rest }: ServiceCenterUpcomingMeetingsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<UpcomingMeetingsResponse> {
    const { data } = await axios.get(`/serviceCenters/${serviceCenterId}/upcoming/meetings`, {
        params: rest,
        signal,
    })

    return data
}
